import { TitleOfBlock, TitleOfBlockProps } from '@uplift/ui-v2';
import { useDashboardStyles } from '../styles';

export type DashboardTitleProps = Pick<TitleOfBlockProps, 'text'>;

export const DashboardTitle: React.FC<DashboardTitleProps> = ({ text }) => {
  const { classes } = useDashboardStyles();

  return <TitleOfBlock text={text} className={classes.dashboardTitle} />;
};
